import * as React from 'react';
import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';
import { compose } from 'redux';

import DisabledFeatures from 'ab-common/environment/disabledFeatures';

import { Button } from '@acceligentllc/storybook';

import * as JobTemplateActions from 'af-actions/jobTracking';

import AssignTemplateModal from './AssignTemplateModal';
import styles from './styles.module.scss';

interface OwnProps {
	refresh: () => void;
	jobId: number;
}

type Props = ConnectedProps<typeof connector> & OwnProps;

const JobTrackingNoTemplate: React.FC<Props> = (props) => {

	const {
		refresh,
		jobId,
		setTemplateToJob,
	} = props;

	const [chooseTemplateModalOpen, setChooseTemplateModalOpen] = React.useState(false);

	const handleAddTemplate = React.useCallback(() => {
		setChooseTemplateModalOpen(true);
	}, []);

	const closeChooseTemplateModal = React.useCallback(() => {
		setChooseTemplateModalOpen(false);
	}, []);

	const handleTemplateSelected = React.useCallback(async (templateId: number) => {
		closeChooseTemplateModal();
		await setTemplateToJob(jobId, templateId);
		refresh();
	}, [closeChooseTemplateModal, jobId, refresh, setTemplateToJob]);

	if (DisabledFeatures.JobTracking) {
		return (
			<div className={styles['no-template-container']}>
				No job tracking data available at this time.
			</div>
		);
	}

	return (
		<>
			<div className={styles['no-template-container']}>
				<Button label="Add template" onClick={handleAddTemplate} style="primary" />
				Add Job Tracking Template to display data
			</div>
			<AssignTemplateModal
				onClose={closeChooseTemplateModal}
				onSave={handleTemplateSelected}
				show={chooseTemplateModalOpen}
			/>

		</>
	);
};

function mapDispatchToProps() {
	return {
		setTemplateToJob: JobTemplateActions.setTemplateToJob,
	};
}

const connector = connect(null, mapDispatchToProps());

const enhance = compose<React.ComponentType<OwnProps>>(
	React.memo,
	connector
);

export default enhance(JobTrackingNoTemplate);
